module.exports = __webpack_public_path__ + "static/media/1POLICY16.d49e01e8.jpg";